// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__3PTY5","row":"styles_row__1S0Lw","header":"styles_header__3bCkE","containerRows":"styles_containerRows__2-aqA","itemConcepts":"styles_itemConcepts__1X1DH"};